import { useEffect, useState } from "react";
import type { VideoConfig } from "./types";
import { VideoGrid } from "./VideoGrid";
import { SettingsMenu } from "./SettingsMenu";
import "./styles.css";

export function App() {
  const [videos, setVideos] = useState<VideoConfig[]>([]);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadVideos();
  }, []);

  const loadVideos = async () => {
    try {
      const response = await fetch("/api/videos");
      if (!response.ok) {
        throw new Error("Failed to load videos");
      }
      const data = await response.json();
      setVideos(data);
      setLoading(false);
    } catch (error) {
      console.error("Error loading videos:", error);
      setLoading(false);
    }
  };

  const toggleVideoVisibility = (videoId: string, visible: boolean) => {
    setVideos((prev) =>
      prev.map((video) =>
        video.id === videoId ? { ...video, visible } : video
      )
    );
    // Save to localStorage
    const visibilityMap: Record<string, boolean> = {};
    videos.forEach((video) => {
      visibilityMap[video.id] = video.id === videoId ? visible : video.visible;
    });
    localStorage.setItem("hamburgtv-visibility", JSON.stringify(visibilityMap));
  };

  if (loading) {
    return (
      <div className="container">
        <div style={{ textAlign: "center", padding: "2rem", color: "#fff" }}>
          Loading videos...
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <button
        id="settings-btn"
        className="settings-btn"
        onClick={() => setSettingsOpen(!settingsOpen)}
        aria-label="Settings"
      >
        ⚙️
      </button>

      <SettingsMenu
        videos={videos}
        isOpen={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        onToggleVisibility={toggleVideoVisibility}
      />

      <VideoGrid videos={videos} />
    </div>
  );
}

export default App;
